import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, G, Path } from 'react-native-svg';

export const LogoDinersClub = ({
  width = 48,
  height = 39,
  className,
}: TIllustrationProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 48 39"
      className={className}
      fill="none"
    >
      <G>
        <Path
          d="M28.12 38.0275C38.5135 38.0773 48 29.5512 48 19.179C48 7.83637 38.5135 -0.00380173 28.12 -2.91567e-05H19.1753C8.65731 -0.00380173 0 7.83871 0 19.179C0 29.5535 8.65731 38.0773 19.1753 38.0275H28.12Z"
          fill="#0079BE"
        />
        <Path
          d="M19.2178 1.57166C9.60678 1.57467 1.81867 9.36504 1.81641 18.9799C1.81867 28.5931 9.6067 36.3827 19.2178 36.3857C28.8311 36.3827 36.6208 28.5931 36.6221 18.9799C36.6207 9.36504 28.8311 1.57467 19.2178 1.57166ZM8.18753 18.9799C8.19659 14.2815 11.1309 10.2751 15.2687 8.68296V29.2744C11.1309 27.6832 8.19651 23.679 8.18753 18.9799ZM23.1654 29.279V8.68228C27.3047 10.2705 30.2435 14.2793 30.2511 18.9799C30.2435 23.682 27.3047 27.6877 23.1654 29.279Z"
          fill="white"
        />
      </G>
    </Svg>
  );
};
